import React, { useState } from "react";
import axios from "axios";

const CulturalSection = () => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    date: "",
    time: "",
    image: null,
  });

  const handleChange = (e) => {
    if (e.target.name === "image") {
      setFormData({
        ...formData,
        image: e.target.files[0],
      });
    } else {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title || !formData.description || !formData.date || !formData.time) {
      alert("All fields are required");
      return;
    }

    try {
      const data = new FormData();
      data.append("title", formData.title);
      data.append("description", formData.description);
      data.append("date", formData.date);
      data.append("time", formData.time);
      data.append("image", formData.image);

      const res = await axios.post(
        "https://admin.stipsredu.in/api/cultural/add",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert("Cultural event added successfully");

      setFormData({
        title: "",
        description: "",
        date: "",
        time: "",
        image: null,
      });

    } catch (error) {
  console.error("Full error:", error);
  console.log("Response:", error.response);

  alert(
    error.response?.data?.message || 
    "Error adding cultural event"
  );
}
  };

  return (
    <div className="bg-[#f8fafc] min-h-screen flex justify-center items-center p-6">
      <div className="bg-white shadow-xl rounded-xl p-8 w-full max-w-2xl">

        <h2 className="text-2xl font-bold text-[#112E65] mb-6">
          Add Cultural Event
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">

          <input
            type="text"
            name="title"
            placeholder="Event Title"
            value={formData.title}
            onChange={handleChange}
            className="w-full border p-3 rounded-lg focus:ring-2 focus:ring-[#112E65]"
          />

          <textarea
            name="description"
            placeholder="Event Description"
            value={formData.description}
            onChange={handleChange}
            rows="4"
            className="w-full border p-3 rounded-lg focus:ring-2 focus:ring-[#112E65]"
          />

          <div className="grid grid-cols-2 gap-4">
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              className="border p-3 rounded-lg focus:ring-2 focus:ring-[#112E65]"
            />

            <input
              type="time"
              name="time"
              value={formData.time}
              onChange={handleChange}
              className="border p-3 rounded-lg focus:ring-2 focus:ring-[#112E65]"
            />
          </div>

          <input
            type="file"
            name="image"
            onChange={handleChange}
            className="w-full border p-3 rounded-lg"
          />

          <button
            type="submit"
            className="w-full bg-[#112E65] text-white py-3 rounded-lg font-semibold hover:bg-[#0d234d]"
          >
            Add Cultural Event
          </button>

        </form>
      </div>
    </div>
  );
};

export default CulturalSection;